import type { LucideProps } from "lucide-react";
import type { ElementType } from "react";

import { Flex } from "components/core/Flex";
import LucideIcon from "components/core/Icon/LucideIcon";

type Props = {
  label: string;
  glyph: ElementType<LucideProps>;
  disabled: boolean;
  onClick: () => void;
};

const StepButton = ({ label, glyph, disabled, onClick }: Props): React.JSX.Element => (
  <Flex
    align="center"
    aria-label={label}
    as="button"
    className="size-11 shrink-0 rounded-lg border border-input bg-card text-foreground disabled:opacity-40"
    disabled={disabled}
    justify="center"
    type="button"
    onClick={onClick}
  >
    <LucideIcon glyph={glyph} size="medium" />
  </Flex>
);

export { StepButton };
